import "./AboutImpact.module.css";
import Header from "@/reusable_sections/Header";
import Mission from "./sections/Mission";
import What4everFreshMeans from "./sections/What4everFreshMeans";
import How4everfreshWorks from "./sections/How4everfreshWorks";
import Transparency from "./sections/Transparency";
import Footer from "@/reusable_sections/Footer";
export default function AboutImpactPage() {
  return <div>
      <Header />
      <Mission />
      <What4everFreshMeans />
      <How4everfreshWorks />
      <Transparency />
      <Footer />
    </div>;
}